module.exports = __webpack_public_path__ + "img/1F61E.655377a5.svg";